import { Typography } from "src/latest/src/components";

import './NoData.scss';

type Props = {
  message?: string | JSX.Element;
  className?: string;
  noBackground?: boolean;
};

const NoData = ({ message, noBackground }: Props) => {
  return (
    <div className={`no-data-container ${noBackground ? 'no-background' : ''}`}>
      {message ? (
        typeof message === 'string' ? (
          <Typography  variant="size-26"  color="color-4">{message}</Typography>
        ) : (
          message
        )
      ) : (
        <Typography variant="size-26" color="color-27">No data found</Typography>
      )}
    </div>
  );
};

export default NoData;

